import { render, staticRenderFns } from "./BanksView.vue?vue&type=template&id=195c8ee6"
import script from "./BanksView.vue?vue&type=script&lang=js"
export * from "./BanksView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports